import React from 'react';

import { CardBack } from '../../../../components/card/card-back';
import { CardFront } from '../../../../components/card/card-front';
import { FlipCard } from '../../../../components/flip-card/flip-card';
import { Text } from '../../../../components/text/text';
import { Translate } from '../../../../components/translate';
import { LANGUAGES } from '../../../../constants/languages';
import { StoreContext } from '../../../../store/store';
import { CARD_CONFIG } from '../../constants/card-config';
import { CARD_4, EXTRA_MILE, GAME_CHANGER } from '../../constants/card-ids';
import '../cards.scss';

const stevieAwardsSrc = {
  [LANGUAGES.EN]: 'https://www.siteground.com/static/2024/en/img/web/sg_birthday/3rd_lesson_stevie_awards.png',
  [LANGUAGES.ES]: 'https://www.siteground.com/static/2024/es/img/web/sg_birthday/3rd_lesson_stevie_awards_es.jpg',
  [LANGUAGES.IT]: 'https://www.siteground.com/static/2024/it/img/web/sg_birthday/3rd_lesson_stevie_awards_it.jpg',
  [LANGUAGES.DE]: 'https://www.siteground.com/static/2024/de/img/web/sg_birthday/3rd_lesson_stevie_awards_de.jpg',
  [LANGUAGES.FR]: 'https://www.siteground.com/static/2024/fr/img/web/sg_birthday/3rd_lesson_stevie_awards_fr.jpg'
};

const CardThree: React.FC = () => {
  const { label, labelColor, title, icon, backfaceIconSRC } = CARD_CONFIG[EXTRA_MILE];
  const { state } = React.useContext(StoreContext);
  const lang = state.config.language;

  return (
    <FlipCard
      cardId={EXTRA_MILE}
      frontContent={<CardFront title={title} label={label} labelColor={labelColor} icon={icon} />}
      backContent={
        <CardBack
          label={label}
          labelColor={labelColor}
          title={title}
          backfaceIconSRC={backfaceIconSRC}
          previousCardId={GAME_CHANGER}
          nextCardId={CARD_4}
        >
          <Text fontFamily="roboto">
            <Translate id="translate.cards.lesson.three.text" />
          </Text>
          <img className="bd-cards__embedded-asset" alt="Stevie Awards Image" src={stevieAwardsSrc[lang]} width={600} />
        </CardBack>
      }
    />
  );
};

export default CardThree;
